import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { backTarget } from '../lib/backToWork';
import { useEntityLinkProps } from './links/useEntityLinkProps';

/**
 * A visible Back to the client's Work list (Christian's walk, 2026-10-28: browser Back works, but staff do not find it).
 * Opened from Work, it returns to the list exactly as it was, filters and all, because Work hands over its own URL as
 * router state. The screen's later URL changes (opening another journal) do not lose it: it is read once, on mount.
 * A real link (fleet ruling 2026-10-29), so it opens in a new tab too.
 */
export default function BackToWork({ clientId }: { clientId: string }) {
  const { t } = useTranslation();
  const location = useLocation();
  // Read on mount: the screen's own later URL changes carry no state. The client is checked on every render.
  const openedWith = useRef<unknown>(location.state).current;
  const to = backTarget(openedWith, clientId);
  const link = useEntityLinkProps(to);

  return (
    <div>
      <Button as="a" appearance="subtle" icon={<ArrowLeftRegular />} {...link}>
        {t('backToWork.label')}
      </Button>
    </div>
  );
}
